import React, { FC } from "react"
import { Col, Row } from "react-bootstrap"
import { useSelector } from "react-redux"

import { ReservedFields } from "@/onboarding/features/product/models/Product"
import Field from "@/onboarding/features/product/components/shared/Field"
import {
  fieldVisible,
  hasProductField,
  templatePrimaryDocumentFieldRenders,
} from "@/onboarding/features/product/selectors"

const Content: FC = () => {
  const hasMeetingLocation = useSelector(hasProductField(ReservedFields.MEETING_LOCATION))
  const meetingLocationVisible = useSelector(
    fieldVisible({ name: ReservedFields.MEETING_LOCATION })
  )
  const showMeetingLocation = hasMeetingLocation && meetingLocationVisible
  const hasAnchoredBuffer = useSelector(
    hasProductField(ReservedFields.MEETING_TIME_BUFFER_ANCHORED)
  )
  const hasDockedBuffer = useSelector(hasProductField(ReservedFields.MEETING_TIME_BUFFER_DOCKED))
  const hasTourDestination = useSelector(templatePrimaryDocumentFieldRenders("tour_destination"))

  return (
    <div className="d-flex flex-column gap-3">
      <Row>
        <Col md={4}>
          <Field name={ReservedFields.START_LOCATION} label="Start Location" />
        </Col>
        {hasTourDestination && (
          <Col md={4}>
            <Field
              name={ReservedFields.TOUR_DESTINATION}
              label="Tour Destination (if different from port of call)"
            />
          </Col>
        )}
        <Col md={4}>
          <Field name={ReservedFields.TOUR_DURATION} label="Tour Duration" />
        </Col>
      </Row>
      {(showMeetingLocation || hasAnchoredBuffer || hasDockedBuffer) && (
        <Row>
          {hasAnchoredBuffer && (
            <Col md={4}>
              <Field
                name={ReservedFields.MEETING_TIME_BUFFER_ANCHORED}
                label="Meeting Time - Anchored"
                helpText="Minutes before departure"
              />
            </Col>
          )}
          {hasDockedBuffer && (
            <Col md={4}>
              <Field
                name={ReservedFields.MEETING_TIME_BUFFER_DOCKED}
                label="Meeting Time - Docked"
                helpText="Minutes before departure"
              />
            </Col>
          )}
          {showMeetingLocation && (
            <Col md={4}>
              <Field name={ReservedFields.MEETING_LOCATION} label="Meeting Location" />
            </Col>
          )}
        </Row>
      )}
    </div>
  )
}

export default Content
